<template>
  <v-container fluid>
    <v-row>
      <v-col cols="8">
        <v-card class="modern-card" height="100%">
          <v-card-title class="modern-title">
            <div class="text-h6 font-weight-bold">Calendario de eventos</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="space-between">
                <v-col cols="4">
                  <v-btn text @click="$refs.calendar.prev()">
                    <v-icon>mdi-arrow-left</v-icon>
                    Mes anterior
                  </v-btn>
                </v-col>
                <v-col cols="4" align="right">
                  <v-btn text @click="$refs.calendar.next()">
                    Mes siguiente
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-calendar
              ref="calendar"
              v-model="calendario"
              color="secondary"
              event-color="secondary"
              :events="calendarPendientesConsultaPrevia"
              @click:event="mostrarEvento($event)"
            ></v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :close-on-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card class="popup-card" min-width="350px" flat>
                <v-card-title class="popup-title">{{ selectedEvent.name }}</v-card-title>
                <v-card-text class="popup-content">
                  <div class="text-subtitle-2 font-weight-bold event-detail">
                    Impartido por: {{ selectedEvent.capacitador }}
                  </div>
                  <div class="text-subtitle-2 font-weight-bold event-detail">Aula: {{ selectedEvent.aula }}</div>
                  <div class="text-subtitle-2 font-weight-bold event-detail">
                    Fecha de finalización: {{ formatDate(selectedEvent.end) }}
                  </div>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="closeMenu()"> Cerrar </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="modern-card">
          <v-card-title class="modern-title">Pendientes de consulta previa</v-card-title>
          <v-card-text>
            <div v-if="pendientesConsultaPrevia.length == 0" class="text-body-1">No hay información para mostrar.</div>
            <template v-else>
              <v-virtual-scroll height="360" item-height="64" :items="pendientesConsultaPrevia">
                <template v-slot:default="{ item }">
                  <v-list-item :key="item.idPersonal" two-line>
                    <v-list-item-avatar>
                      <v-avatar color="secondary" size="80">
                        <v-icon color="white">mdi-account</v-icon>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="text-body-1 font-weight-bold">
                          {{ getFullName(item) }}
                        </div>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div class="text-body-2">CURP: {{ item.curp }}</div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import validator from 'validator'

export default {
  data() {
    return {
      calendario: '',

      selectedOpen: false,
      selectedEvent: {},
      selectedElement: null,
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirantes: 'getPreaspirantes',
    }),

    ...mapGetters('pendientesConsultaPrevia', {
      pendientesConsultaPrevia: 'getPendientesConsultaPrevia',
    }),

    calendarPendientesConsultaPrevia: function () {
      var programacion = []

      // this.cursosProgramados.forEach(cursoProgramado => {
      //     if (
      //         validator.isDate(moment(cursoProgramado.fechaInicio).format(this.VUETIFY_DATE_FORMAT), { format: this.VUETIFY_DATE_FORMAT }) &&
      //         validator.isDate(moment(cursoProgramado.fechaFin).format(this.VUETIFY_DATE_FORMAT), { format: this.VUETIFY_DATE_FORMAT })
      //     ) {
      //         programacion.push({
      //             name: 'Inicio de curso: ' + cursoProgramado.Subcategoria.subcategoria,
      //             aula: cursoProgramado.Aula.aula,
      //             capacitador: this.getFullName(cursoProgramado.Capacitador),
      //             start: moment(cursoProgramado.fechaInicio).format(this.VUETIFY_DATE_FORMAT),
      //             end: moment(cursoProgramado.fechaFin).format(this.VUETIFY_DATE_FORMAT),
      //         })
      //     }
      // })

      return programacion
    },
  },

  methods: {
    mostrarEvento(event) {
      this.selectedEvent = event.event
      this.selectedOpen = true
    },

    closeMenu() {
      this.selectedOpen = false
    },
  },
}
</script>

<style scoped>
/* Modern Cards with Glass-morphism */
.modern-card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
  animation: fadeInUp 0.6s ease-out !important;
}

.modern-title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  color: #e0e0e0 !important;
  font-weight: 700 !important;
}

::v-deep .modern-card .v-card__text {
  padding: 24px !important;
}

/* Popup Card */
.popup-card {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(15px) !important;
  -webkit-backdrop-filter: blur(15px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  border-radius: 16px !important;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.5) !important;
}

.popup-title {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
  padding: 20px 24px 16px !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
}

.popup-content {
  padding: 20px 24px !important;
}

.event-detail {
  color: rgba(224, 224, 224, 0.9) !important;
  margin-bottom: 8px;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative !important;
  overflow: hidden !important;
}

::v-deep .v-btn:hover:not(:disabled):not(.v-btn--text) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-btn.secondary:not(.v-btn--text) {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
}

::v-deep .v-btn--text {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-btn--text:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease !important;
  color: inherit !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Calendar */
::v-deep .v-calendar {
  background: transparent !important;
  border-radius: 12px !important;
  overflow: hidden;
}

::v-deep .v-calendar .v-calendar-weekly__head {
  background: rgba(0, 0, 0, 0.2) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
}

::v-deep .v-calendar .v-calendar-weekly__head-weekday {
  color: var(--v-secondary-base) !important;
  font-weight: 600 !important;
  border: none !important;
}

::v-deep .v-calendar .v-calendar-weekly__day {
  border-right: 1px solid rgba(var(--v-secondary-base-rgb), 0.1) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-calendar .v-calendar-weekly__day-label {
  color: #e0e0e0 !important;
}

::v-deep .v-calendar .v-calendar-weekly__day-month {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-calendar .v-event {
  border-radius: 8px !important;
  background: var(--v-secondary-base) !important;
  box-shadow: 0 2px 8px rgba(var(--v-secondary-base-rgb), 0.4) !important;
  border: none !important;
}

::v-deep .v-calendar .v-outside {
  background: rgba(0, 0, 0, 0.1) !important;
}

/* List Items */
::v-deep .v-list-item {
  border-radius: 12px !important;
  margin: 8px 0 !important;
  transition: all 0.3s ease !important;
  background: rgba(0, 0, 0, 0.2) !important;
}

::v-deep .v-list-item:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
  transform: translateX(4px);
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  color: #e0e0e0 !important;
}

::v-deep .v-list-item__avatar {
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover .v-list-item__avatar {
  border-color: var(--v-secondary-base);
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb), 0.4);
}

/* Virtual Scroll */
::v-deep .v-virtual-scroll {
  border-radius: 12px;
}

/* Textos */
.text-body-1,
.text-body-2,
.text-subtitle-2 {
  color: #e0e0e0 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

/* Animación de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}
</style>
